import React from 'react';

import Portal from "Utilities/PortalMaker";

function ReactQueryDevToolsPortal({ children }) {
  const portalToElement = document.querySelector("body");

  if (!portalToElement) return null;
  return (
    <Portal to={portalToElement}>
      {children}
    </Portal>
  )
}

export default ReactQueryDevToolsPortal